import React, { useState, useContext } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import TopNav from '../nav/TopNav';
import styled from 'styled-components';
import ShoppingContext from '../../context/shoping/shoppingContext';

const StyledBurger = styled.div`
  input[type='email'],
  input[type='text'],
  select {
    padding: 3px 1rem;
    color: #fff;
    background: none;
    outline: none;
    border-radius: 0.8rem;
    box-shadow: none;
    border: 1px solid #fff;
  }
  input[type='email']:focus,
  input[type='text']:focus {
    // background: #000;
    outline: none;
    box-shadow: none;
  }
  // input[type='email']:focus,
  // input[type='text']:focus,
  // input[type='password']:focus {
  //   border-bottom: 1px solid #000;
  // }
`;

const ShippingAddressGuest = () => {
  const shoppingContext = useContext(ShoppingContext);

  const { freeShipping } = shoppingContext;

  const [user, setUser] = useState({
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    address: '',
    number: '',
    city: '',
    Country: '',
    state: '',
    pincode: '',
  });

  const {
    firstname,
    lastname,
    email,
    number,
    address,
    city,
    Country,
    state,
    pincode,
  } = user;

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <Container className='LiveThrowdown p-0' fluid>
      <TopNav />
      <Container className='text-light'>
        <h2>Shipping Address</h2>
        <NavLink to='/apparel' className='underline-text'>
          <u>Continue Shopping</u>
        </NavLink>

        <StyledBurger>
          <Container xl={6} lg={8} className='my-3 py-3 '>
            <Row className=' p-2'>
              <Col md={6} className='p-2'>
                <form onSubmit={onSubmit}>
                  <div className=' my-4'>
                    <div>
                      <label htmlFor=''>email</label>
                    </div>
                    <input
                      type='email'
                      name='email'
                      value={email}
                      onChange={onChange}
                      className='input_cust_styles'
                    />
                    <div className='my-2'>
                      <label className='cust_check-box'>
                        Keep me up to date on news and exclusive offers
                        <input type='checkbox' name='check' />
                        <span className='checkmark'></span>
                      </label>
                    </div>
                  </div>

                  <div className=' my-4'>
                    <div>
                      <label htmlFor=''>Contact Number</label>
                    </div>
                    <div className=''>
                      <select
                        name='num'
                        value={number}
                        onChange={onChange}
                        className='special-inp1 '
                        id='num'
                      >
                        <option value='+91'>+91</option>
                        <option value='+1'>+1</option>
                        <option value='+7'>+7</option>
                        <option value='+61'>+61</option>
                      </select>
                      <input
                        type='text'
                        className='text-light special-inp2 ml-3'
                      />
                    </div>
                  </div>

                  <div className='d-flex my-4'>
                    <div>
                      <div>
                        <label htmlFor=''>First name</label>
                      </div>
                      <input
                        type='text'
                        name='firstname'
                        value={firstname}
                        onChange={onChange}
                        className='input_inline'
                      />
                    </div>
                    <div>
                      <div>
                        <label htmlFor='' className='ml-4'>
                          Last name
                        </label>
                      </div>
                      <input
                        type='text'
                        name='lastname'
                        value={lastname}
                        onChange={onChange}
                        className='input_inline ml-4'
                      />
                    </div>
                  </div>

                  <div className='my-4'>
                    <div>
                      <label htmlFor=''>
                        Address (House no, Building, Street, Area)
                      </label>
                    </div>
                    <input
                      type='text'
                      name='address'
                      value={address}
                      onChange={onChange}
                      className='input_cust_styles'
                    />
                  </div>

                  <div className='my-4'>
                    <div>
                      <label htmlFor=''>city</label>
                    </div>
                    <input
                      type='text'
                      name='city'
                      value={city}
                      onChange={onChange}
                      className='input_cust_styles'
                    />
                  </div>

                  <div className='my-4'>
                    <div>
                      <label htmlFor='cars'>Country</label>
                    </div>
                    <select
                      name='Country'
                      value={Country}
                      onChange={onChange}
                      id='country'
                      className='input_cust_styles'
                    >
                      <option value='United States'>United States</option>
                      <option value='saab'>Saab</option>
                      <option value='opel'>Opel</option>
                      <option value='audi'>Audi</option>
                    </select>
                  </div>

                  <div className='my-4'>
                    <div>
                      <label htmlFor='cars'>state</label>
                    </div>

                    <select
                      name='state'
                      value={state}
                      onChange={onChange}
                      id='state'
                      className='input_cust_styles'
                    >
                      <option value='Alabama'>Alabama</option>
                      <option value='saab'>Saab</option>
                      <option value='opel'>Opel</option>
                      <option value='audi'>Audi</option>
                    </select>
                  </div>

                  <div className='my-4'>
                    <div>
                      <div>Postal Code</div>
                      <input
                        type='text'
                        value={pincode}
                        onChange={onChange}
                        name='pincode'
                        className='input_cust_styles1'
                        placeholder='5220022'
                      />
                      <button
                        type='submit'
                        className='btn btn-theam input_cust_styles1 ml-3'
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </form>
              </Col>

              <Col md={6} className='mt-5 pl-5'>
                <div className='shipping_cart_box p-4 '>
                  <div className=' mb-4 text-capitalize '>
                    {freeShipping.map((shopping) => (
                      <Col key={shopping.id}>
                        <Row className='my-2'>
                          <Col className='d-flex p-0'>
                            <div className=' shipping-img'>
                              {shopping.image}
                            </div>
                            <div className='pl-4 shipping-img-heading'>
                              <div className=''>{shopping.heading}</div>

                              <div className='my-1'>
                                <p className='m-0 pl-1'>XS / Black</p>
                              </div>
                              <div className='my-1'>
                                <p className='m-0'>Qty: 2</p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    ))}
                  </div>
                  <div className=' my-2'>
                    <div>Have a coupon?</div>
                    <div className='d-flex'>
                      <input
                        type='text'
                        className='border border-dark text-dark'
                      />
                      <button className='ml-3 btn border border-dark text-dark text-capitalize'>
                        apply
                      </button>
                    </div>
                  </div>
                  <div className='d-flex shipping_cart-bold my-2'>
                    <div>Shopping Cart</div>
                    <div className='ml-auto'>$ 20</div>
                  </div>{' '}
                  <div className='d-flex shipping_cart-bold'>
                    <div>Shipping</div>
                    <div className='ml-auto'>$ 10</div>
                  </div>{' '}
                  <div className='d-flex shipping_cart-bold  mt-3'>
                    <div>Total</div>
                    <div className='ml-auto text-strong'>$ 30</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </StyledBurger>
      </Container>
    </Container>
  );
};
export default ShippingAddressGuest;
